import { render } from "./PhraseView.vue?vue&type=template&id=a3c93d9e&ts=true"
import script from "./PhraseView.vue?vue&type=script&lang=ts"
export * from "./PhraseView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__